import { render, staticRenderFns } from "./CVTypeAddition.vue?vue&type=template&id=72ff9a68"
import script from "./CVTypeAddition.vue?vue&type=script&lang=js"
export * from "./CVTypeAddition.vue?vue&type=script&lang=js"
import style0 from "./CVTypeAddition.vue?vue&type=style&index=0&id=72ff9a68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports